import { inject, Injectable, Signal } from '@angular/core';
import { locationAncestryNames } from '@app/states/locations/locations.selectors';
import { Store } from '@ngrx/store';

@Injectable({
	providedIn: 'root',
})
export class LocationAncestryService {
	private readonly store$ = inject(Store);

	locationAncestryNames: Signal<Map<string, string>> =
		this.store$.selectSignal(locationAncestryNames);

	replaceName<T extends { pk?: string; locationId?: string; name: string }>(
		location: T
	): T {
		const locationName = this.locationAncestryNames().get(
			location.pk || location.locationId
		);
		if (!locationName) return location;

		return {
			...location,
			name: locationName,
		} as T;
	}
}
